import axios from "axios";
import React, { useEffect } from "react";
import { useState } from "react";
import { Modal } from "react-bootstrap";

const ClientMaster = () => {
  const [dataList, setDataList] = useState([]);
  const [firmName, setFirmName] = useState('');
  const [statusLoan, setStatusLoan] = useState('');
  const [firmType, setFirmType] = useState('');
  const [companySize, setCompanySize] = useState('');
  const [gstNum, setGstNum] = useState('');
  const [currAccNum, setCurrAccNum] = useState('');
  const [city, setCity] = useState('')
  const [state, setState] = useState('')
  const [businessAdd, setBusinessAdd] = useState('');
  const [addCategory, setAddCategory] = useState('urban');
  const [occupancyType, setOccupancyType] = useState('selfowned');
  const [electricityName, setElectricityName] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [clientId, setClientId] = useState('');
  const [eleConnType, setEleConnType] = useState('')
  const [typeOfServices, setTypeOfServices] = useState('')
  const [noOfEmploye, setNoOfEmploye] = useState('')
  const [sollarPower, setSollarPower] = useState(0)

  const [validFirmName, setValidFirmName] = useState('firm');
  const [validGstNum, setValidGstNum] = useState('gst');
  const [validCurrAccNum, setValidCurrAccNum] = useState('curr');
  const [validBusinessAdd, setValidBusinessAdd] = useState('bussiness');
  const [validElectricityName, setValidElectricityName] = useState('electricity');
  const [validCategory, setValidCategory] = useState('category');
  const [validOccType, setValidOccType] = useState('occ')
  const [validCity, setValidCity] = useState('city')
  const [validState, setValidState] = useState('state');
  const [validEleConnType, setValidEleConnType] = useState('conn')
  const [validTypeOfServices, setValidTypeOfServices] = useState('service')
  const [ValidNoOfEmploye, setValidNoOfEmploye] = useState('emp')

  const validateForm = () => {
    let valid = false;
    let regex = new RegExp(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/);
    if (firmName === "") {
      setValidFirmName(firmName);
      valid = true;
    }
    const validRegex = regex.test(gstNum)
    if (gstNum === "") {
      setValidGstNum(gstNum);
      valid = true;
    } else if (validRegex === false) {
      setValidGstNum(validRegex);
      valid = true;
    }
    if (currAccNum === "") {
      setValidCurrAccNum(currAccNum);
      valid = true;
    }
    if (typeOfServices === '') {
      setValidTypeOfServices(typeOfServices)
      valid = true
    }

    if (noOfEmploye === '') {
      setValidNoOfEmploye(noOfEmploye)
      valid = true
    }
    if (eleConnType === '') {
      setValidEleConnType(eleConnType);
      valid = true;
    }

    if (businessAdd === "") {
      setValidBusinessAdd(businessAdd);
      valid = true;
    }
    if (city === "") {
      setValidCity(city);
      valid = true;
    }
    if (state === "") {
      setValidState(state);
    }
    if (electricityName === "") {
      setValidElectricityName(electricityName);
      valid = true;
    }
    if (addCategory === "") {
      setValidCategory(addCategory);
      valid = true;
    }
    if (occupancyType === "") {
      setValidOccType(occupancyType);
      valid = true;
    }
    return valid;
  };

  const handleAddClientClick = () => {
    setEditMode(false)
    setShowModal(true);
    setFirmName('')
    setStatusLoan('unsecured')
    setFirmType('proprietor')
    setCompanySize('micro')
    setGstNum('')
    setCurrAccNum('')
    setCity('')
    setState('')
    setBusinessAdd('')
    setAddCategory('urban')
    setOccupancyType('selfowned')
    setElectricityName('')
    setEleConnType('')
    setTypeOfServices('')
    setNoOfEmploye('')
    setSollarPower(0)
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setValidFirmName('firm')
    setValidGstNum('gst')
    setValidCurrAccNum('curr')
    setValidBusinessAdd('bussiness')
    setValidElectricityName('electricity')
    setValidCategory('category')
    setValidOccType('occ')
    setValidCity('city')
    setValidState('state');
    setValidEleConnType('conn')
    setValidTypeOfServices('service')
    setValidNoOfEmploye('emp')
  };

  const handleEditData = (value) => {
    setEditMode(true);
    setShowModal(true);
    setFirmName(value.nameFirm)
    setStatusLoan(value.statusLoan)
    setFirmType(value.typeFirm)
    setCompanySize(value.companySize)
    setNoOfEmploye(value.noOfEmploye)
    setTypeOfServices(value.typeOfServices)
    setGstNum(value.gstNo)
    setCity(value.city)
    setState(value.state)
    setCurrAccNum(value.currentAccNo)
    setBusinessAdd(value.businessAdd)
    setAddCategory(value.addCategory)
    setOccupancyType(value.occupancyType)
    setElectricityName(value.electricityConn)
    setClientId(value.clientId)
    setEleConnType(value.eleConnType)
    setSollarPower(value.sollarPower)
  }
  const handleNext = async () => {
    if (!validateForm()) {
      if (editMode) {
        try {
          const response = await axios.put(`${process.env.REACT_APP_API_URL}/update-client/${clientId}`,
            {
              nameFirm: firmName,
              statusLoan: statusLoan,
              typeFirm: firmType,
              companySize: companySize,
              noOfEmploye: noOfEmploye,
              typeOfServices: typeOfServices,
              gstNo: gstNum,
              currentAccNo: currAccNum,
              city: city,
              state: state,
              businessAdd: businessAdd,
              addCategory: addCategory,
              occupancyType: occupancyType,
              electricityConn: electricityName,
              eleConnType: eleConnType,
              sollarPower: sollarPower
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('signIn')}`
              }
            }
          );

          if (response.status === 201) {
            setShowModal(false);
            handleData()
          }
        } catch (error) {
          console.error('Error submitting client data:', error);
        }
      } else {
        try {
          const response = await axios.post(`${process.env.REACT_APP_API_URL}/create-client`,
            {
              nameFirm: firmName,
              statusLoan: statusLoan,
              typeFirm: firmType,
              companySize: companySize,
              gstNo: gstNum,
              currentAccNo: currAccNum,
              city: city,
              state: state,
              businessAdd: businessAdd,
              addCategory: addCategory,
              occupancyType: occupancyType,
              electricityConn: electricityName
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('signIn')}`
              }
            }
          );
          if (response.status === 201) {
            setShowModal(false);
            handleData()
          }
        } catch (error) {
          console.error('Error submitting client data:', error);
        }
      }
    }
  };

  const handleData = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/get-all-clients`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('signIn')}`
        }
      }
    );
    const clients = response.data.result;

    if (clients && clients.length > 0) {
      setDataList(clients);
    } else {
      console.log('No records available.');
    }
  };
  useEffect(() => {
    handleData();
  }, []);

  return (
    <div id="main" className="main">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1 style={{ margin: '5px', textAlign: 'center', flex: '1' }}>Client Master</h1>
        <button
          className="btn btn-dark"
          style={{ marginRight: '17px' }}
          onClick={handleAddClientClick}
        ><i className="bi bi-plus-lg"></i> Client</button>
      </div>
      <Modal show={showModal} onHide={handleCloseModal} style={{ 'width': '100%' }}>
        <Modal.Header closeButton>
          <Modal.Title>{editMode === true ? 'Edit Client' : 'Add Client'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container" style={{ 'marginTop': '15px' }}>
            <form>
              <div className='form-row'>
                <div className='form-group col-md-6'>
                  <label>Name of Firm</label>
                  <input type='text'
                    className={`form-control ${validFirmName === '' && 'is-invalid'}`}
                    value={firmName}
                    onChange={e => { setFirmName(e.target.value); setValidFirmName(e.target.value) }}
                  />
                  {validFirmName === '' && (
                    <p className="invalid-feedback">Firm name is required</p>
                  )}
                </div>

                <div className='form-group col-md-6'>
                  <label>Status of Loan</label>

                  <select className='custom-select mr-sm-2'
                    value={statusLoan}
                    onChange={e => setStatusLoan(e.target.value)}
                  >
                    <option value='sanction'>Sanction</option>
                    <option value='disbursed'>Disbursed</option>
                  </select>
                </div>
              </div>
              <div className='form-row'>
                <div className='form-group col-md-12'>
                  <label>Type of Firm</label>

                  <select className='custom-select mr-sm-2'
                    value={firmType}
                    onChange={e => setFirmType(e.target.value)}
                  >
                    <option value='proprietor'>Proprietor</option>
                    <option value='partner'>Partner</option>
                    <option value='corporation'>Corporation</option>
                  </select>
                </div>
              </div>
              <div className='form-row'>
                <div className='form-group col-md-6'>
                  <label>Number of Employee</label>
                  <select
                    className={`custom-select mr-sm-2 ${ValidNoOfEmploye === '' && 'is-invalid'}`}
                    value={noOfEmploye}
                    onChange={e => {
                      setNoOfEmploye(e.target.value);
                      setValidNoOfEmploye(e.target.value)
                    }}
                  >
                    <option value=''>Select</option>
                    <option value='lessThen100'>Less then 100</option>
                    <option value='100-200'>100 - 200</option>
                    <option value='200-500'>200 - 500</option>
                    <option value='moreThen500'>More then 500</option>
                  </select>
                  {ValidNoOfEmploye === '' && (
                    <p className="invalid-feedback">No of Employee is required</p>
                  )}
                </div>
                <div className='form-group col-md-6'>
                  <label>Type of Services</label>
                  <select className={`custom-select mr-sm-2  ${validTypeOfServices === '' && 'is-invalid'}`}
                    value={typeOfServices}
                    onChange={e => {
                      setTypeOfServices(e.target.value);
                      setValidTypeOfServices(e.target.value)
                    }}
                  >
                    <option value=''>Select</option>
                    <option value='services'>Services Sector</option>
                    <option value='manufacturing'>Manufacturing Sector</option>
                  </select>
                  {validTypeOfServices === '' && (
                    <p className="invalid-feedback">No of Employee is required</p>
                  )}
                </div>
              </div>
              <div className='form-row'>
                <div className='form-group col-md-6'>
                  <label>Gst Number</label>
                  <input type='text'
                    className={`form-control ${(validGstNum === '' || validGstNum === false) && 'is-invalid'}`}
                    value={gstNum}
                    onChange={e => { setGstNum(e.target.value); setValidGstNum(e.target.value); }}
                  />
                  {validGstNum === '' ? (
                    <p className="invalid-feedback">GST number is required</p>
                  ) : <p className="invalid-feedback">Please specify a valid GSTTIN Number</p>}
                </div>
                <div className='form-group col-md-6'>
                  <label>Current Account No</label>
                  <input type='number'
                    className={`form-control ${validCurrAccNum === '' && 'is-invalid'}`}
                    value={currAccNum}
                    onChange={e => {
                      setCurrAccNum(e.target.value);
                      setValidCurrAccNum(e.target.value)
                    }}
                  />
                  {validCurrAccNum === '' && (
                    <p className="invalid-feedback">Current account number is required</p>
                  )}
                </div>
              </div>

              <div className='form-row'>
                <div className='form-group col-md-12'>
                  <label>Business Address</label>
                  <input type='text'
                    className={`form-control ${validBusinessAdd === '' && 'is-invalid'}`}
                    value={businessAdd}
                    onChange={e => { setBusinessAdd(e.target.value); setValidBusinessAdd(e.target.value) }}
                  />
                  {validBusinessAdd === '' && (
                    <p className="invalid-feedback">Business address is required</p>
                  )}
                </div>
              </div>
              <div className='form-row'>
                <div className='form-group col-md-6'>
                  <label>Electricity Connection Type</label>
                  <select
                    className={`custom-select mr-sm-2 ${validEleConnType === '' && 'is-invalid'}`}
                    value={eleConnType}
                    onChange={e => {
                      setEleConnType(e.target.value);
                      setValidEleConnType(e.target.value)
                    }}
                  >
                    <option value=''>Select</option>
                    <option value='LT'>LT</option>
                    <option value='HT'>HT</option>
                  </select>
                  {validBusinessAdd === '' && (
                    <p className="invalid-feedback">Electricity Connection Type is required</p>
                  )}
                </div>
                <div className='form-group col-md-6'>
                  <label>Electricity Connection Name</label>
                  <input type='text'
                    className={`form-control ${validElectricityName === '' && 'is-invalid'}`}
                    value={electricityName}
                    onChange={e => { setElectricityName(e.target.value); setValidElectricityName(e.target.value) }}
                  />
                  {validElectricityName === '' && (
                    <p className="invalid-feedback">Electricity Connection name is required</p>
                  )}
                </div>
              </div>
              <div className='form-row'>
                <div className='form-group col-md-6'>
                  <label>City</label>
                  <select
                    className={`custom-select mr-sm-2 ${validCity === '' && 'is-invalid'}`}
                    value={city}
                    onChange={e => {
                      setCity(e.target.value);
                      setValidCity(e.target.value)
                    }}
                  >
                    <option value=''>Select</option>
                    <option value='surat'>Surat</option>
                  </select>
                  {validCity === '' && (
                    <p className="invalid-feedback">City is required</p>
                  )}
                </div>
                <div className='form-group col-md-6'>
                  <label>State</label>
                  <select
                    className={`custom-select mr-sm-2 ${validState === '' && 'is-invalid'}`}
                    value={state}
                    onChange={e => {
                      setState(e.target.value);
                      setValidState(e.target.value)
                    }}
                  >
                    <option value=''>Select</option>
                    <option value='gujarat'>Gujarat</option>
                  </select>
                  {validState === '' && (
                    <p className="invalid-feedback">State is required</p>
                  )}
                </div>
              </div>
              <div className='form-row'>
                <div className='form-group col-md-6'>
                  <label>Address Category</label>
                  <select
                    className={`custom-select mr-sm-2 ${validCategory === '' && 'is-invalid'}`}
                    value={addCategory}
                    onChange={e => {
                      setAddCategory(e.target.value);
                      setValidCategory(e.target.value)
                    }}
                  >
                    <option value=''>Select</option>
                    <option value='category_1'>Category 1</option>
                    <option value='category_2'>Category 2</option>
                    <option value='category_3'>Category 3</option>
                  </select>
                  {validCategory === '' && (
                    <p className="invalid-feedback">Address category is required</p>
                  )}
                </div>
                <div className='form-group col-md-6'>
                  <label>Occupancy Type</label>
                  <select
                    className={`custom-select mr-sm-2 ${validOccType === '' && 'is-invalid'}`}
                    value={occupancyType}
                    onChange={e => {
                      setOccupancyType(e.target.value);
                      setValidOccType(e.target.value)
                    }}
                  >
                    <option value=''>Select</option>
                    <option value='selfowned'>Self Owned</option>
                    <option value='rented'>Rented</option>
                  </select>
                  {validOccType === '' && (
                    <p className="invalid-feedback">Occupancy is required</p>
                  )}
                </div>
              </div>
              <div className='form-row'>
                <div className='form-check col-md-12'>
                  <input type='checkbox'
                    className={`form-check-input`}
                    checked={sollarPower === 1}
                    onChange={e => { setSollarPower(e.target.checked ? 1 : 0); }}
                  />
                  <label className="form-check-label">Do you have a power tariff?</label>
                </div>

              </div>
              <div className='col-md-8 mx-auto'>
                <div className='form-group text-center'>
                  <button type='button'
                    onClick={handleCloseModal}
                    style={{ border: '1px solid gray', marginRight: '10px' }}
                    className='btn btn-default btn res-btn-gray'
                  >
                    Close
                  </button>
                  <button
                    type='button'
                    style={{ border: '1px solid gray' }}
                    className='btn btn-default col-xs-offset-1'
                    onClick={handleNext}
                  >
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
      <div className="col-lg-12">
        <div className="card mb-8">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead>
                  <tr>
                    <th>Add Category</th>
                    <th>Name Firm</th>
                    <th>Business Address</th>
                    <th>Company Size</th>
                    <th>Electricity Connection</th>
                    <th>Occupancy Type</th>
                    <th>Status Loan</th>
                    <th>Type Firm</th>
                    <th className="text-end"> Action </th>
                  </tr>
                </thead>
                <tbody>
                  {dataList?.map((value, index) =>

                    <tr key={index}>
                      <td>{value?.addCategory}</td>
                      <td>{value?.nameFirm}</td>
                      <td>{value?.businessAdd}</td>
                      <td>{value?.companySize}</td>
                      <td>{value?.electricityConn}</td>
                      <td>{value?.occupancyType}</td>
                      <td>{value?.statusLoan}</td>
                      <td>{value?.typeFirm}</td>
                      <td className="text-end" style={{ verticalAlign: 'middle' }}>
                        <button
                          className="btn btn-sm btn-dark rounded font-sm mt-15"
                          style={{ marginRight: '8px' }}
                          onClick={() => handleEditData(value)}
                        >Edit</button>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientMaster;
